module.exports = __webpack_public_path__ + "static/img/1.91199cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/webgl/ui/img/1.png
// module id = X/xU
// module chunks = 49